<div class="filter-builder-container"
  [ngClass]="{'form-layout-compact': useCompactFormLayout}">
    @if (!options.subjectInitialValue) {
      <div class="row">
        <div class="field">
          <input soho-radiobutton type="radio" soho-trackdirty name="optionsConditionGroupMatch" id="optionsConditionGroupMatchAll" value="all" [(ngModel)]="model.matchOption" (change)="onMatchChange($event)" data-automation-id="lm-filter-builder-match-all"/>
          <label for="optionsConditionGroupMatchAll" class="radio-label" data-automation-id="lm-filter-builder-match-all-label">{{ 'CreateReportMatchAllLabel' | translate }}</label>
          <input soho-radiobutton type="radio" soho-trackdirty name="optionsConditionGroupMatch" id="optionsConditionGroupMatchAny" value="any" [(ngModel)]="model.matchOption" (change)="onMatchChange($event)" data-automation-id="lm-filter-builder-match-any"/>
          <label for="optionsConditionGroupMatchAny" class="radio-label" data-automation-id="lm-filter-builder-match-any-label">{{ 'CreateReportMatchAnyLabel' | translate }}</label>
        </div>
      </div>
    }

  <div class="row field-short">
    <h3>{{ 'Conditions' | translate }}</h3>
  </div>
  @for (data of filterRows; track data; let i = $index; let isFirst = $first; let isLast = $last) {
    <lm-filter-builder-row
      [filterRow] = "data"
      [builderOptions]="options"
      [index] = "i"
      (handleRemoveRowEvent)="onRemoveButtonEvent($event, i)"
      >
    </lm-filter-builder-row>
    @if (filterRows.length > 1 && !isLast) {
      <div class="flex-separator-container field">
        <div class="flex-separator-column"><hr></div>
        <p class="and-separator lm-bold">{{separator === ' and ' ? ('AndSeparator' | translate) : ('OrSeparator' | translate)}}</p>
        <div class="flex-separator-column"><hr></div>
      </div>
    }
  }
</div>
@if (!options.subjectInitialValue) {
    <div class="buildAnother-btn">
        <button
                soho-button="primary"
                (click)="onAddButtonEvent($event)"
                soho-alert
                data-automation-id="lm-filter-builder-build-another"
        >{{ 'BuildAnother' | translate }}</button>
    </div>

}
